import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import Modal from "components/Util/Modal";

import { addBinanceUser, updateBinanceUser } from "api/settings";

type BinanceUserModalProps = {
  isOpen: boolean;
  onClose: () => void;
  id?: string;
  name?: string;
};

export default function BinanceUserModal({
  isOpen,
  onClose,
  id,
  name = "",
}: BinanceUserModalProps) {
  const { user } = useAuth0();
  const [username, setUsername] = useState(name);
  const [key, setKey] = useState("");
  const [secret, setSecret] = useState("");

  const submit = async () => {
    const userId = user["https://hasura.io/jwt/claims"]["x-hasura-user-id"];
    const value = JSON.stringify({
      username,
      key,
      secret,
    });

    let data;

    if (id) {
      data = await updateBinanceUser(
        userId,
        id,
        username,
        value.replace(/[""]/g, '"')
      );
    } else {
      data = await addBinanceUser(userId, value.replace(/[""]/g, '\\"'));
    }

    console.log(data);
    setUsername("");
    setKey("");
    setSecret("");
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`${!id ? "Add" : "Edit"} Binance User`}
    >
      <>
        <form className="my-5 grid gap-5 md:grid-cols-4 items-center">
          <label className="text-xs font-medium">Username</label>
          <input
            type="text"
            className="form-input col-span-3 mx-1 rounded-sm border border-gray-200 text-xs"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <label className="text-xs font-medium">Api Key</label>
          <input
            type="text"
            className="form-input col-span-3 mx-1 rounded-sm border border-gray-200 text-xs"
            placeholder="Api Key"
            value={key}
            onChange={(e) => setKey(e.target.value)}
          />
          <label className="text-xs font-medium">Api Secret</label>
          <input
            type="text"
            className="form-input col-span-3 mx-1 rounded-sm border border-gray-200 text-xs"
            placeholder="Api Secret"
            value={secret}
            onChange={(e) => setSecret(e.target.value)}
          />
        </form>
        <div className="mt-4 flex justify-end -m-6 px-6 bg-gray-50 py-5 border-t">
          <button
            type="button"
            className="form-input inline-flex items-center border border-transparent leading-4 font-medium shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-sm px-4 text-sm py-2 bg-green-400 hover:bg-green-500 focus:ring-green-500"
            onClick={submit}
          >
            Save
          </button>
          <button
            type="button"
            className="ml-3 inline-flex items-center border leading-4 font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 rounded-sm px-4 text-sm py-2 bg-white hover:bg-gray-50 text-current border-gray-200"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </>
    </Modal>
  );
}
